// extracted by css-extract-rspack-plugin
export default {"transactionLabel":"transactionLabel-p48jQZ","transactionValue":"transactionValue-EEYUUt","divider":"divider-EXPyLq","rowContainer":"rowContainer-cKtjKn"};